// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"K6-z","colorTextValue":"L6-z","swatches":"M6-z","collapseLink":"N6-z","isCollapsed":"O6-z","dropdown":"P6-z","disabled":"Q6-z"};